import { Col, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";

const ViewLotSizeModal = (props) => {

    const singleLotSizeData = props.singleLotSizeData;

    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>View Lot Size</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Lot Size Procedure</label>
                                        <span>{singleLotSizeData[0]?.LotSizeProcedure || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>LS</label>
                                        <span>{singleLotSizeData[0]?.LS || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>LI</label>
                                        <span>{singleLotSizeData[0]?.LI || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label> Pds </label>
                                        <span>{singleLotSizeData[0]?.PDS || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label> LLP </label>
                                        <span>{singleLotSizeData[0]?.LLP || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label> LLI </label>
                                        <span>{singleLotSizeData[0]?.LLI || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label> Lper </label>
                                        <span>{singleLotSizeData[0]?.LPER || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={8}>
                                    <div className="view-sla-data">
                                        <label> Description </label>
                                        <span>{singleLotSizeData[0]?.Description || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label> Status </label>
                                        <span>{singleLotSizeData[0]?.Status || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewLotSizeModal;